import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';

/**
 * Rental agreement outstanding amount KPI DTO
 */
@CaslSubject(AppSubjectEnum.RENTAL_AGREEMENT)
export class KpiRentalAgreementOutstandingAmountDto {
	rentalAgreementId!: number;
	dateDue!: Date;
	amountDue!: number;
	amountDeposited!: number;
	amountRefunded!: number;
	amountPaid!: number;
	amountOutstanding!: number;
}
